import {
  Box,
  Button,
  Card,
  Chip,
  Divider,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import "./processes-procedures.css";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getProcessesProcedureRequest,
  getProcessesProcedureSuccess,
} from "../../../../../redux/clients/slice";
import Loading from "../../../../../components/loading/loading";
import EditCancellation from "./edit-cancellation/edit-cancellation";
import EditOrderHandling from "./edit-order-handling/edit-order-handling";
import EditInspectorRequirement from "./edit-inspector-requirements/edit-inspector-requirements";
import {
  deliveryMethodOptions,
  invoiceFrequencyOptions,
} from "../../../../../utils/Constant";
import EditServicesFees from "./edit-services-fees/edit-services-fees";
import { getInsuranceTypesRequest } from "../../../../../redux/inspection-firms/slice";
import dayjs from "dayjs";

type props = {
  data?: any;
};

export default function ProcessesProcedures({ data }: props) {
  const [processesProcedure, setProcessesProcedure] = useState<any>();
  const [showEditCancellation, setShowEditCancellation] = useState(false);
  const [showEditOrderHandling, setShowEditOrderHandling] = useState(false);
  const [showEditInspectorRequirements, setShowEditInspectorRequirements] =
    useState(false);
  const [showEditServicesFees, setShowEditServicesFees] = useState(false);

  const dispatch = useDispatch();
  const { processesProcedure: proceduresResponse, loading } = useSelector(
    (state: any) => state?.clients
  );
  const { insuranceTypes } = useSelector((state: any) => state.inspectionFirms);

  useEffect(() => {
    if (data) {
      dispatch(getProcessesProcedureSuccess({ response: null }));
      dispatch(getProcessesProcedureRequest({ id: data?.id }));
      if (insuranceTypes.length === 0) dispatch(getInsuranceTypesRequest());
    }
  }, [data]); // eslint-disable-line

  useEffect(() => {
    if (proceduresResponse) {
      setProcessesProcedure(proceduresResponse);
    }
  }, [proceduresResponse]);

  const handleEditOrderHandling = () => {
    setShowEditOrderHandling(true);
  };

  const handleEditCancellation = () => {
    setShowEditCancellation(true);
  };

  const handleEditInspectorRequirements = () => {
    setShowEditInspectorRequirements(true);
  };

  const handleEditServices = () => {
    setShowEditServicesFees(true);
  };

  const renderDeliveryMethod = (
    deliveryMethod: string,
    attachFileLabel?: boolean
  ) => {
    if (!deliveryMethod) return <>-</>;
    const option = deliveryMethodOptions.find(
      (item) => item.value === deliveryMethod
    );
    if (!option) return <>{deliveryMethod}</>;
    const label =
      attachFileLabel && option.value === "Email"
        ? "Attach File to Email"
        : option.label;
    return (
      <>
        {label}
        {option.hint && (
          <Typography
            component="span"
            sx={{
              ml: 0.5,
              fontWeight: 400,
              fontSize: "12px",
              color: "var(--text-secondary, #00000099)",
            }}
          >
            {option.hint}
          </Typography>
        )}
      </>
    );
  };

  const getInsuranceLable = (insuranceType: string) => {
    const insurance = insuranceTypes.find(
      (type: any) => type?.insuranceType === insuranceType
    );
    if (insurance) {
      return insurance?.displayName;
    }
  };

  return (
    <Box>
      <Card className="procedure-card-layout">
        <Box className="card-header">
          <Typography variant="h5">Order Handling</Typography>
          <Button
            variant="text"
            startIcon={<EditOutlinedIcon />}
            onClick={handleEditOrderHandling}
          >
            Edit
          </Button>
        </Box>
        <Box className="Received-layout">
          <Typography className="label-txt">Orders Received</Typography>
          {processesProcedure?.notificationEvents?.orderReceived ? (
            <Box>
              <Box className="chip-layout">
                <Typography className="delivery-label">
                  Delivery Method:
                </Typography>
                <Typography ml={1}>
                  {renderDeliveryMethod(
                    processesProcedure?.notificationEvents?.orderReceived
                      ?.deliveryMethod
                  )}
                </Typography>
              </Box>
              <Box className="chip-layout" mt={1}>
                <Typography className="delivery-label">
                  Delivered To:
                </Typography>
                <Box>
                  {processesProcedure?.notificationEvents?.orderReceived
                    ?.recipients?.length > 0 ? (
                    processesProcedure?.notificationEvents?.orderReceived?.recipients?.map(
                      (item: any) => (
                        <Chip
                          sx={{ ml: 1 }}
                          key={item.id}
                          label={item.fullName}
                          variant="outlined"
                          color="primary"
                          size="small"
                        ></Chip>
                      )
                    )
                  ) : (
                    <Typography ml={1}>-</Typography>
                  )}
                </Box>
              </Box>
            </Box>
          ) : (
            <>-</>
          )}
        </Box>
        <Divider />
        <Box className="result-layout">
          <Typography className="label-txt">Submit Results</Typography>
          <Box>
            {processesProcedure?.notificationEvents.submitResults?.client && (
              <Box>
                <Box className="chip-layout">
                  <Typography className="delivery-label">
                    Delivery Method:
                  </Typography>
                  <Typography ml={1}>
                    {renderDeliveryMethod(
                      processesProcedure?.notificationEvents.submitResults
                        ?.client?.deliveryMethod,
                      true
                    )}
                  </Typography>
                </Box>
                <Box className="chip-layout" mt={1}>
                  <Typography className="delivery-label">
                    Delivered To:
                  </Typography>
                  <Box>
                    {processesProcedure?.notificationEvents.submitResults?.client?.recipients.map(
                      (recipients: any) => (
                        <Chip
                          sx={{ ml: 1 }}
                          key={recipients.id}
                          label={recipients?.fullName}
                          variant="outlined"
                          color="primary"
                          size="small"
                        ></Chip>
                      )
                    )}
                  </Box>
                </Box>
                {processesProcedure?.notificationEvents.submitResults?.client
                  ?.notes && (
                  <Box className="chip-layout" mt={1}>
                    <Typography className="delivery-label">
                      Delivery Note:
                    </Typography>
                    <Typography ml={1}>
                      {
                        processesProcedure?.notificationEvents.submitResults
                          ?.client?.notes
                      }
                    </Typography>
                  </Box>
                )}
              </Box>
            )}

            {processesProcedure?.notificationEvents.submitResults?.subDivisions
              ?.length > 0 &&
              processesProcedure?.notificationEvents.submitResults?.subDivisions?.map(
                (item: any, index: number) => (
                  <Box key={item.organizationId} mt={index === 0 ? 0 : 1.5}>
                    <Typography className="divisionName">
                      {item?.organizationName}
                    </Typography>
                    <Box className="chip-layout">
                      <Typography className="delivery-label">
                        Delivery Method:
                      </Typography>
                      <Typography ml={1}>
                        {renderDeliveryMethod(item?.deliveryMethod, true)}
                      </Typography>
                    </Box>
                    <Box className="chip-layout" mt={1}>
                      <Typography className="delivery-label">
                        Delivered To:
                      </Typography>
                      <Box>
                        {item.recipients.map((recipients: any) => (
                          <Chip
                            sx={{ ml: 1 }}
                            key={recipients.id}
                            label={recipients.fullName}
                            variant="outlined"
                            color="primary"
                            size="small"
                          ></Chip>
                        ))}
                      </Box>
                    </Box>
                    {item.notes && (
                      <Box className="chip-layout" mt={1}>
                        <Typography className="delivery-label">
                          Delivery Note:
                        </Typography>
                        <Typography ml={1}>{item.notes}</Typography>
                      </Box>
                    )}
                  </Box>
                )
              )}

            {!processesProcedure?.notificationEvents.submitResults?.client &&
              !processesProcedure?.notificationEvents.submitResults
                ?.subDivisions && <> - </>}
          </Box>
        </Box>
        <Divider />
        <Box className="result-layout">
          <Typography className="label-txt">Submit Invoice</Typography>
          <Box>
            {processesProcedure?.notificationEvents.submitInvoice?.client && (
              <Box>
                <Box className="chip-layout">
                  <Typography className="invoice-label">Frequency:</Typography>
                  <Typography ml={1}>
                    {invoiceFrequencyOptions.filter(
                      (option) =>
                        option.value ===
                        processesProcedure?.notificationEvents.submitInvoice
                          ?.client?.frequency
                    )?.[0]?.label || "-"}
                  </Typography>
                </Box>
                <Box className="chip-layout" mt={1}>
                  <Typography className="invoice-label">
                    File Format:
                  </Typography>
                  <Typography ml={1}>
                    {processesProcedure?.notificationEvents.submitInvoice
                      ?.client?.format || "-"}
                  </Typography>
                </Box>
                <Box className="chip-layout" mt={1}>
                  <Typography className="invoice-label">
                    Delivery Method:
                  </Typography>
                  <Typography ml={1}>
                    {renderDeliveryMethod(
                      processesProcedure?.notificationEvents.submitInvoice
                        ?.client?.deliveryMethod,
                      true
                    )}
                  </Typography>
                </Box>
                <Box className="chip-layout" mt={1}>
                  <Typography className="invoice-label">
                    Delivered To:
                  </Typography>
                  <Box>
                    {processesProcedure?.notificationEvents.submitInvoice?.client?.recipients.map(
                      (recipients: any) => (
                        <Chip
                          sx={{ ml: 1 }}
                          key={recipients.id}
                          label={recipients.fullName}
                          size="small"
                          variant="outlined"
                          color="primary"
                        ></Chip>
                      )
                    )}
                  </Box>
                </Box>
                {processesProcedure?.notificationEvents.submitInvoice?.client
                  ?.notes && (
                  <Box className="chip-layout" mt={1}>
                    <Typography className="invoice-label">
                      Delivery Note:
                    </Typography>
                    <Typography ml={1}>
                      {
                        processesProcedure?.notificationEvents.submitInvoice
                          ?.client?.notes
                      }
                    </Typography>
                  </Box>
                )}
              </Box>
            )}

            {processesProcedure?.notificationEvents.submitInvoice?.subDivisions
              ?.length > 0 &&
              processesProcedure?.notificationEvents.submitInvoice?.subDivisions?.map(
                (item: any, index: number) => (
                  <Box key={item.organizationId} mt={index === 0 ? 0 : 1.5}>
                    <Typography className="divisionName">
                      {item?.organizationName}
                    </Typography>
                    <Box className="chip-layout">
                      <Typography className="invoice-label">
                        Frequency:
                      </Typography>
                      <Typography ml={1}>
                        {invoiceFrequencyOptions.filter(
                          (option) => option.value === item.frequency
                        )?.[0]?.label || "-"}
                      </Typography>
                    </Box>
                    <Box className="chip-layout" mt={1}>
                      <Typography className="invoice-label">
                        File Format:
                      </Typography>
                      <Typography ml={1}>{item.format || "-"}</Typography>
                    </Box>
                    <Box className="chip-layout" mt={1}>
                      <Typography className="invoice-label">
                        Delivery Method:
                      </Typography>
                      <Typography ml={1}>
                        {renderDeliveryMethod(item.deliveryMethod, true)}
                      </Typography>
                    </Box>
                    <Box className="chip-layout" mt={1}>
                      <Typography className="invoice-label">
                        Delivered To:
                      </Typography>
                      <Box>
                        {item.recipients.map((recipients: any) => (
                          <Chip
                            sx={{ ml: 1 }}
                            key={item.id}
                            label={recipients.fullName}
                            size="small"
                            variant="outlined"
                            color="primary"
                          ></Chip>
                        ))}
                      </Box>
                    </Box>
                    {item.notes && (
                      <Box className="chip-layout" mt={1}>
                        <Typography className="invoice-label">
                          Delivery Note:
                        </Typography>
                        <Typography ml={1}>{item.notes}</Typography>
                      </Box>
                    )}
                  </Box>
                )
              )}

            {!processesProcedure?.notificationEvents.submitInvoice?.client &&
              !processesProcedure?.notificationEvents.submitInvoice
                ?.subDivisions && <> - </>}
          </Box>
        </Box>
        <Divider />
        <Box className="result-layout">
          <Typography className="label-txt">Project Invoice</Typography>
          <Box>
            {processesProcedure?.notificationEvents.projectInvoice ? (
              <Box>
                <Box className="chip-layout">
                  <Typography className="invoice-label">
                    File Format:
                  </Typography>
                  <Typography ml={1}>
                    {processesProcedure?.notificationEvents.projectInvoice
                      ?.format || "-"}
                  </Typography>
                </Box>
                <Box className="chip-layout" mt={1}>
                  <Typography className="invoice-label">
                    Delivery Method:
                  </Typography>
                  <Typography ml={1}>
                    {renderDeliveryMethod(
                      processesProcedure?.notificationEvents.projectInvoice
                        ?.deliveryMethod,
                      true
                    )}
                  </Typography>
                </Box>
                <Box className="chip-layout" mt={1}>
                  <Typography className="invoice-label">
                    Delivered To:
                  </Typography>
                  <Box>
                    {processesProcedure?.notificationEvents.projectInvoice?.recipients.map(
                      (recipients: any) => (
                        <Chip
                          sx={{ ml: 1 }}
                          key={recipients.id}
                          label={recipients.fullName}
                          size="small"
                          variant="outlined"
                          color="primary"
                        ></Chip>
                      )
                    )}
                  </Box>
                </Box>
                {processesProcedure?.notificationEvents.projectInvoice
                  ?.notes && (
                  <Box className="chip-layout" mt={1}>
                    <Typography className="invoice-label">
                      Invoice Note:
                    </Typography>
                    <Typography ml={1}>
                      {
                        processesProcedure?.notificationEvents.projectInvoice
                          ?.notes
                      }
                    </Typography>
                  </Box>
                )}
              </Box>
            ) : (
              <> - </>
            )}
          </Box>
        </Box>
      </Card>

      <Card className="cards-layout">
        <Box className="card-header">
          <Typography variant="h5">Cancellation</Typography>
          <Button
            variant="text"
            startIcon={<EditOutlinedIcon />}
            onClick={handleEditCancellation}
          >
            Edit
          </Button>
        </Box>
        <Box className="procedure-layout">
          <Typography className="label-txt">Cancellation Procedure</Typography>
          <Typography>
            {processesProcedure?.procedures.cancellation ? (
              processesProcedure?.procedures.cancellation
            ) : (
              <>-</>
            )}
          </Typography>
        </Box>
        <Divider />
        <Box className="contact-procedure-layout">
          <Typography className="label-txt">
            Contact No-Show <br />
            Procedure
          </Typography>
          <Typography>
            {processesProcedure?.procedures?.contactNoShow ? (
              processesProcedure?.procedures?.contactNoShow
            ) : (
              <>-</>
            )}
          </Typography>
        </Box>
      </Card>

      <Card className="cards-layout">
        <Box className="card-header">
          <Typography variant="h5">Inspector Requirements</Typography>
          <Button
            variant="text"
            startIcon={<EditOutlinedIcon />}
            onClick={handleEditInspectorRequirements}
          >
            Edit
          </Button>
        </Box>
        <Box className="inspectors-layout">
          <Typography className="label-txt">Inspector Must Have</Typography>
          <Box>
            {processesProcedure?.restriction ? (
              <Box className="chip-layout">
                <Typography>Background Check Completed</Typography>
                <Chip
                  sx={{ ml: 2 }}
                  size="small"
                  color="primary"
                  variant="outlined"
                  label={
                    processesProcedure?.restriction?.backgroundCheckDone
                      ? "True"
                      : "False"
                  }
                />
              </Box>
            ) : (
              <>-</>
            )}

            {processesProcedure?.restriction?.insurances &&
              processesProcedure?.restriction?.insurances.length > 0 && (
                <Box className="chip-layout" mt={1}>
                  <Typography>Insurance Required</Typography>
                  {processesProcedure?.restriction?.insurances.map(
                    (insurance: string) => (
                      <Chip
                        key={insurance}
                        sx={{ ml: 2 }}
                        size="small"
                        color="primary"
                        variant="outlined"
                        label={getInsuranceLable(insurance) || ""}
                      />
                    )
                  )}
                </Box>
              )}
          </Box>
        </Box>
        <Divider />
        <Box className="inspectors-layout">
          <Box sx={{ display: "flex", alignItems: "flex-start" }}>
            <Typography className="label-txt">
              Blocklisted <br />
              Inspection Firms
            </Typography>
            <Tooltip
              title="Blocklisted inspection firms will be excluded from ANY inspection for this client. This may be requested by the client or the inspector. This data is only visible to Spectrum users."
              arrow
              placement="top"
            >
              <IconButton sx={{ p: 0, ml: -5, mr: 2 }}>
                <InfoOutlinedIcon color="primary" />
              </IconButton>
            </Tooltip>
          </Box>
          <Box>
            {processesProcedure?.inspectorFirmBlacklists &&
            processesProcedure?.inspectorFirmBlacklists.length > 0 ? (
              processesProcedure?.inspectorFirmBlacklists.map(
                (entry: any, idx: number) => (
                  <Box key={idx} mt={idx === 0 ? 0 : 2}>
                    <Box className="chip-layout">
                      <Chip
                        size="small"
                        color="primary"
                        variant="outlined"
                        label={
                          entry?.inspectorFirm?.displayName ||
                          entry?.inspectorFirm?.aliasName ||
                          ""
                        }
                      />
                      <Typography
                        className="label-txt"
                        sx={{
                          ml: 2,
                          fontSize: "16px !important",
                          fontStyle: "italic",
                          width: "auto",
                          minWidth: 0,
                        }}
                      >
                        {entry?.createdAt && entry?.createdByUser?.fullName
                          ? `Created ${dayjs(entry.createdAt).format(
                              "MMM D, YYYY"
                            )} by ${entry.createdByUser.fullName}`
                          : ""}
                      </Typography>
                    </Box>
                    {entry?.reason && (
                      <Typography mt={0.5}>{entry.reason}</Typography>
                    )}
                  </Box>
                )
              )
            ) : (
              <>-</>
            )}
          </Box>
        </Box>
      </Card>

      <Card className="cards-layout">
        <Box className="card-header">
          <Typography variant="h5">Schedule of Services & Fee</Typography>
          <Button
            variant="text"
            startIcon={<EditOutlinedIcon />}
            onClick={handleEditServices}
          >
            Edit
          </Button>
        </Box>
        <Box className="services-layout">
          <Typography className="label-txt">Services</Typography>
          <Box sx={{ width: "100%" }}>
            <Box display={"flex"} sx={{ width: "100%" }}>
              <Typography fontWeight={600} flex={2.5}>
                Inspection Type
              </Typography>
              <Typography fontWeight={600} flex={1} textAlign={"center"}>
                Contracted Turn Time
              </Typography>
              <Typography fontWeight={600} flex={1} textAlign={"center"}>
                Contracted Client Fee
              </Typography>
              <Typography fontWeight={600} flex={1} textAlign={"center"}>
                Inspector Fee
              </Typography>
            </Box>
            <Box>
              {processesProcedure?.services?.length > 0 ? (
                processesProcedure?.services?.map((item: any) => (
                  <Box
                    key={item.inspectionType}
                    display={"flex"}
                    sx={{ width: "100%", mt: 1 }}
                  >
                    <Typography flex={2.5}>
                      {item?.inspectionTypeName}
                    </Typography>
                    <Typography flex={1} textAlign={"center"}>
                      {item?.turnTimeInDays} Business Days
                    </Typography>
                    <Typography flex={1} textAlign={"center"}>
                      ${item?.clientFee}
                    </Typography>
                    <Typography flex={1} textAlign={"center"}>
                      ${item?.inspectorFee}
                    </Typography>
                  </Box>
                ))
              ) : (
                <>-</>
              )}
            </Box>
          </Box>
        </Box>
        <Divider />
        <Box className="services-layout">
          <Typography className="label-txt">Rush Fees</Typography>
          <Box sx={{ width: "100%" }}>
            <Box display={"flex"} sx={{ width: "100%" }}>
              <Typography fontWeight={600} flex={2.5}>
                Rush Fee Label
              </Typography>
              <Typography fontWeight={600} flex={1} textAlign={"center"}>
                Client Fee
              </Typography>
              <Typography fontWeight={600} flex={1} textAlign={"center"}>
                InspectorFee
              </Typography>
            </Box>
            <Box>
              {processesProcedure?.rushFees?.length > 0 ? (
                processesProcedure?.rushFees?.map((item: any) => (
                  <Box
                    key={item.id}
                    display={"flex"}
                    sx={{ width: "100%", mt: 1 }}
                  >
                    <Typography flex={2.5}>{item?.label}</Typography>
                    <Typography flex={1} textAlign={"center"}>
                      ${item?.clientFee}
                    </Typography>
                    <Typography flex={1} textAlign={"center"}>
                      ${item?.inspectorFee}
                    </Typography>
                  </Box>
                ))
              ) : (
                <>-</>
              )}
            </Box>
          </Box>
        </Box>
        <Divider />
        <Box className="surcharges-layout">
          <Typography className="label-txt">Misc Fees & Surcharges</Typography>
          <Box>
            <Box display={"flex"}>
              <Typography className="fee-type">Fee Type</Typography>
              <Typography className="fee">Fee</Typography>
              <Typography className="definition">Definition</Typography>
            </Box>
            <Box display={"flex"}>
              <Typography className="fee-type-lbl">Cancellation Fee</Typography>
              <Typography className="fee-lbl">
                {processesProcedure?.fee?.cancellationFee ? (
                  <>${processesProcedure?.fee?.cancellationFee}</>
                ) : (
                  <>-</>
                )}
              </Typography>
            </Box>
            <Box display={"flex"}>
              <Typography className="fee-type-lbl">Trip Fee</Typography>
              <Typography className="fee-lbl">
                {processesProcedure?.fee?.tripFee ? (
                  <>${processesProcedure?.fee?.tripFee}</>
                ) : (
                  <>-</>
                )}
              </Typography>
            </Box>
            <Box display={"flex"}>
              <Typography className="fee-type-lbl">Remote Area Fee</Typography>
              <Typography className="fee-lbl">
                {processesProcedure?.fee?.remoteAreaFee ? (
                  <>${processesProcedure?.fee?.remoteAreaFee}</>
                ) : (
                  <>-</>
                )}
              </Typography>
              <Typography className="definition-lbl">
                {" "}
                {processesProcedure?.fee?.remoteAreaDefinition ? (
                  processesProcedure.fee.remoteAreaDefinition
                ) : (
                  <>-</>
                )}
              </Typography>
            </Box>
            <Box>
              {processesProcedure?.fee?.rushFees?.length > 0 &&
                processesProcedure?.fee?.rushFees?.map(
                  (fee: any, index: number) => (
                    <Box display={"flex"} key={index}>
                      <Typography className="fee-type-lbl">
                        {fee?.rushDays} {fee.label}
                      </Typography>
                      <Typography className="fee-lbl">${fee?.fee}</Typography>
                    </Box>
                  )
                )}
            </Box>
          </Box>
        </Box>
      </Card>
      {showEditCancellation && (
        <EditCancellation
          showDialog={showEditCancellation}
          closeDialog={() => setShowEditCancellation(false)}
          data={processesProcedure?.procedures}
          clientId={data?.id}
        />
      )}
      {showEditOrderHandling && (
        <EditOrderHandling
          showDialog={showEditOrderHandling}
          closeDialog={() => setShowEditOrderHandling(false)}
          data={processesProcedure?.notificationEvents}
          clientId={data?.id}
        />
      )}
      {showEditInspectorRequirements && (
        <EditInspectorRequirement
          showDialog={showEditInspectorRequirements}
          closeDialog={() => setShowEditInspectorRequirements(false)}
          restrictionData={processesProcedure?.restriction}
          blockListInspectionFirmData={
            processesProcedure?.inspectorFirmBlacklists
          }
          clientId={data?.id}
        />
      )}
      {showEditServicesFees && (
        <EditServicesFees
          showDialog={showEditServicesFees}
          closeDialog={() => setShowEditServicesFees(false)}
          data={processesProcedure}
          clientId={data?.id}
        />
      )}
      {loading && <Loading />}
    </Box>
  );
}
